import { colors } from '@microfrontends/react-components'
import styled from 'styled-components'

export const ContentWrapper = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 48px;
    margin: 16px 0;
    h2 {
        margin-top: 16px;
    }
    ul {
        li {
            margin-bottom: 8px;
        }
    }
    ol, ul {
        &.style-none {
            list-style: none;
            padding-left: 0;
        }
        &.no-list-style {
            list-style: none;
        }
    }
    .m-l {
        margin-left: 32px;
    }
    .align-center {
        text-align: center;
    }

    table.custom-table {
        td {
            border: 1px solid ${colors.grey[40]};
            padding: 8px;
        }
        .header {
            font-weight: 600;
        }
        
    }

    @media (max-width: 768px) {
        padding: 16px;
        h1 {
            font-size: 20px;
        }
        h2 {
            font-size: 18px;
        }
        h3 {
            font-size: 17px;
        }
        h4 {
            font-size: 16px;
        }
        ol {
            margin-left: 8px !important;
        }
        ul {
            padding-left: 8px !important;
        }
    }
`

export const IframeWrapper = styled.iframe`
    width: 100%;
    border: 1px solid ${colors.grey[80]};
    border-radius: 16px;
`
